module footer {
  'use strict';

	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class FooterCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$location',
      '$anchorScroll', 
      '$animate',
      '$element',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IFooterScope,
      private $location: ng.ILocationService,
      private $anchorScroll: any, //ng.IAnchorScrollService
      private $animate: any, //angular.animate.IAnimateService,
      private $element: JQuery,
      private pageMetaService: navigation.IPageMetaService
      ) {

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      $animate.on('enter', $element,
        function callback(element:JQuery, phase:string) {
          if (element.hasClass("detail")) {
            $anchorScroll();
          }
        }
      );
       
    }

    setActiveTab(activeTabIndex : number, url : string, event? : JQueryEventObject) {
      if (event) event.preventDefault();
      if (this.$scope.activeTabIndex == activeTabIndex) {
        this.$scope.activeTabIndex = -1;
      } else {
        this.$scope.activeTabIndex = activeTabIndex;
      }
      this.$location.path(url);
      this.$anchorScroll();
    }


  }

}